import React from "react";

import { INotification } from "infrastructure/notification";

import { BannerMessage } from "./BannerMessage";

interface IBannerProps {
  messages?: INotification[];
  removeNotificationAction: (messageIndex: number) => void;
  messageClassName?: string;
  shouldScroll?: (message: INotification) => boolean;
}

export const Banner: React.FC<IBannerProps> = ({ messages, removeNotificationAction, messageClassName, shouldScroll }) => {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {messages &&
        messages.map((val, key) => (
          <BannerMessage shouldScroll={shouldScroll} key={key} type={val.type} data={val} index={key} removeAction={removeNotificationAction} className={messageClassName} />
        ))}
    </>
  );
};
